var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line",class:_vm.classes,style:(_vm.style)},[(_vm.statementLine)?_c('connection-line-statement',{attrs:{"statement":_vm.text,"statementLine":_vm.statementLine},on:{"statementChange":function($event){_vm.statementChange($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184bd50e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConnectionLine.vue
// module id = null
// module chunks = 